import PropTypes from 'prop-types';
import React from 'react';
import Money from '../../components/Money';
import Modal from '../../components/Modal';
import Icon, { GLYPHS } from '../../components/Icon';
import TaxesAndFees from './TaxesAndFees';
import * as shapes from '../../shapes';

const OrderInformation = ({
  servicesNamesShort,
  servicesNamesLong,
  serviceCost,
  totalAmount,
  costWithTaxes,
  activeTip,
  taxes,
  toggled,
  on,
  off,
  discount,
  bookNoPayQuery,
  isSquireFeeShop,
  isChopMurrayHillShop,
  taxBreakdown,
  shouldShowTip,
  showOnlyCostAndTaxes,
  headingClassName,
  className,
  isGiftCardDiscount,
  fees,
  membershipDiscount,
}) => (
  <div className={className}>
    <div className={headingClassName}>Order Information</div>
    <div className="c-order-info">
      <div className="c-order-info__desc">
        {servicesNamesLong && (
          <div
            role="button"
            className="c-btn c-btn--bare u-inline-block u--mt-- u-mr--"
            onClickCapture={(e) => {
              e.preventDefault();
              e.stopPropagation();
              on();
            }}
            tabIndex="0"
          >
            <Icon glyph={GLYPHS.INFO} />
          </div>
        )}
        <div className="u-inline-block">{servicesNamesShort}:</div>
      </div>
      <div className="c-order-info__price">
        <Money>{serviceCost}</Money>
      </div>
      {shouldShowTip && (
        <div className="c-order-info__desc">Tip: {activeTip.value ? `${Math.floor(activeTip.value)}%` : ''}</div>
      )}
      {shouldShowTip && <div className="c-order-info__price"><Money>{activeTip.amount}</Money></div>}
      {!bookNoPayQuery && (
        <TaxesAndFees
          taxes={taxes}
          fees={fees}
          isSquireFeeShop={isSquireFeeShop}
          isChopMurrayHillShop={isChopMurrayHillShop}
          taxBreakdown={taxBreakdown}
        />
      )}
      {discount ? <div className="c-order-info__desc">
        {isGiftCardDiscount ? 'Gift Card' : 'Discount'}:
      </div> : null}
      {discount ? <div className="c-order-info__price u-co-red">
        -<Money>{discount}</Money>
      </div> : null}
      {!!membershipDiscount && (
        <div className="c-order-info__desc">
          Membership discount:
        </div>
      )}
      {!!membershipDiscount && (
        <div className="c-order-info__price u-co-red">
          -<Money>{membershipDiscount}</Money>
        </div>
      )}
      <hr className="c-separator u-mt u-mb- c-order-info__separator" />
      <div className="u-pt-- u-co-black-2">
        <div className="c-order-info__desc u-type--extrabold">Total:</div>
        <div className="c-order-info__price u-type--extrabold">
          <Money>{showOnlyCostAndTaxes ? costWithTaxes : totalAmount}</Money>
        </div>
      </div>
    </div>
    {toggled && (
      <Modal size="small" close={off}>
        <div className="u-co-gray">{servicesNamesLong}</div>
      </Modal>
    )}
  </div>
);
OrderInformation.propTypes = {
  activeTip: shapes.tipShape,
  taxes: PropTypes.number.isRequired,
  fees: PropTypes.number.isRequired,
  discount: PropTypes.number,
  totalAmount: PropTypes.number.isRequired,
  costWithTaxes: PropTypes.number.isRequired,
  servicesNamesShort: PropTypes.string,
  servicesNamesLong: PropTypes.string,
  serviceCost: PropTypes.number,
  toggled: shapes.flag.isRequired,
  on: shapes.handler.isRequired,
  off: shapes.handler.isRequired,
  bookNoPayQuery: PropTypes.bool.isRequired,
  isSquireFeeShop: PropTypes.bool.isRequired,
  isChopMurrayHillShop: PropTypes.bool.isRequired,
  taxBreakdown: shapes.taxBreakdownArray,
  shouldShowTip: PropTypes.bool.isRequired,
  showOnlyCostAndTaxes: PropTypes.bool.isRequired,
  headingClassName: PropTypes.string,
  className: PropTypes.string,
  isGiftCardDiscount: PropTypes.bool,
  membershipDiscount: PropTypes.number.isRequired,
};
OrderInformation.defaultProps = {
  activeTip: null,
  taxes: '',
  servicesNamesShort: '',
  servicesNamesLong: '',
  serviceCost: 0,
  discount: 0,
  taxBreakdown: [],
  headingClassName: 'c-heading c-heading--huge u-mb',
  className: '',
  isGiftCardDiscount: false,
  showOnlyCostAndTaxes: false,
};

export default OrderInformation;



// WEBPACK FOOTER //
// ./src/app/reservation/components/OrderInformation.jsx